export const appGroupIdGenerateImage = "/:app_group_id/generate_image";
